export default {

  TIPO_LECHE_CALIENTE: 3,
  TIPO_LECHE_FRIA: 4,

}